import { useOnboardingStore } from '@/store/onboardingStore';

/* ─── Screen 0: Welcome ─────────────────────────────────────── */

export function WelcomeScreen() {
    const { nextStep, skip } = useOnboardingStore();

    return (
        <div className="flex flex-col items-center justify-center min-h-[70vh] text-center px-6">
            {/* Logo / Brand Mark */}
            {/* Logo / Brand Mark */}
            <div className="w-24 h-24 rounded-2xl bg-gradient-to-br from-gold-500/10 to-gold-600/5 flex items-center justify-center mb-8 ring-1 ring-gold-500/20 p-4 shadow-[0_0_30px_rgba(212,175,55,0.15)]">
                <img src="/logo.png" alt="Palaestra Academy" className="w-full h-full object-contain drop-shadow-md" />
            </div>

            <h1 className="text-2xl font-bold text-text-primary mb-2">
                Palaestra Academy
            </h1>
            <p className="text-text-secondary text-sm leading-relaxed max-w-[280px] mb-10">
                Set up your training recommendations in 30 seconds.
            </p>

            <div className="w-full max-w-[280px] space-y-3">
                <button
                    onClick={nextStep}
                    className="w-full py-3.5 rounded-2xl bg-gradient-to-r from-gold-500 to-gold-600 text-bg font-bold text-sm tracking-wide shadow-[0_4px_20px_rgba(212,175,55,0.3)] hover:shadow-[0_4px_28px_rgba(212,175,55,0.45)] transition-all duration-200 active:scale-[0.98]"
                >
                    Continue
                </button>
                <button
                    onClick={skip}
                    className="w-full py-3 rounded-2xl text-text-muted text-sm hover:text-text-secondary transition-colors"
                >
                    Skip for now
                </button>
            </div>
        </div>
    );
}
